import {
  GET_WAREHOUSES,
  UPDATE_WAREHOUSES,
  CREATE_WAREHOUSES,
  UPDATE_WAREHOUSES_STATUS,
  GET_WAREHOUSE_WITH_ID,
  UPDATE_WAREHOUSE_ADMIN,
  GET_WAREHOUSE_CHILDREN,
  GET_SKUS_INVENTORY,
  GET_WAREHOUSES_INVENTORY_BY_ID,
  GET_PARCELS_ITEMS,
  GET_SKUS_INVENTORY_BY_ID,
  GET_SKUS_INVENTORY_FINALIZED_SUM,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM,
  GET_WAREHOUSE_OPERATORS_BY_ID,
} from './constants';
import {
  PayloadUpdate,
  PayloadCreate,
  PayloadInventory,
  PayloadChildren,
  PayloadInventoryById,
} from './interfaces';

export function getWarehousesAction(payload: Object) {
  return {
    type: GET_WAREHOUSES,
    payload,
  };
}

export function updateWarehouseActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_WAREHOUSES,
    payload,
  };
}

export function createWarehousesActions(payload: PayloadCreate) {
  return {
    type: CREATE_WAREHOUSES,
    payload,
  };
}

export function getWarehouseOperatorsActions(payload: Object) {
  return {
    type: GET_WAREHOUSE_OPERATORS_BY_ID,
    payload,
  };
}

export function getWarehousesInventoryByIdActions(
  payload: PayloadInventoryById
) {
  return {
    type: GET_WAREHOUSES_INVENTORY_BY_ID,
    payload,
  };
}

export function getSkusInventoryActions(payload: PayloadInventory) {
  return {
    type: GET_SKUS_INVENTORY,
    payload,
  };
}

export function getSkusInventoryFinalizedSumActions(
  payload: PayloadInventoryById
) {
  return {
    type: GET_SKUS_INVENTORY_FINALIZED_SUM,
    payload,
  };
}

export function getSkusInventoryNotFinalizedSumActions(
  payload: PayloadInventoryById
) {
  return {
    type: GET_SKUS_INVENTORY_NOT_FINALIZED_SUM,
    payload,
  };
}

export function getSkuInventoryWithIdAction(payload: {
  id: number;
  pagination: object;
}) {
  return {
    type: GET_SKUS_INVENTORY_BY_ID,
    payload,
  };
}

export function updateWarehousesStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_WAREHOUSES_STATUS,
    payload,
  };
}

export function getWarehouseWithIdAction(payload: {id: number}) {
  return {
    type: GET_WAREHOUSE_WITH_ID,
    payload,
  };
}

export function updateWarehouseAdminActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_WAREHOUSE_ADMIN,
    payload,
  };
}

export function getWarehouseChildrenAction(payload: PayloadChildren) {
  return {
    type: GET_WAREHOUSE_CHILDREN,
    payload,
  };
}

export function getParcelsItemsAction(payload: Object) {
  return {
    type: GET_PARCELS_ITEMS,
    payload,
  };
}
